import React, { useMemo } from 'react';
import { mui } from '~/tools/mui';
import { jss } from '~/tools/jss';

const useStyles = jss.makeStyles(() => ({
  container: {
    width: '100%',
  },
}));

type ListSkeletonProps = {
  rowsCount?: number;
  rowHeight?: number;
  SkeletonProps?: any;
};

const ListSkeleton = ({ rowsCount = 1, rowHeight = 80, SkeletonProps }: ListSkeletonProps) => {
  const classes = useStyles();
  const rows = useMemo(() => Array(rowsCount).fill(null), [rowsCount]);

  return (
    <div className={classes.container} data-testid="list-skeleton-container">
      {rows.map((entry, index) => (
        <mui.Skeleton data-testid="skeleton-row" key={`loading-row-${index}`} height={rowHeight} {...SkeletonProps} />
      ))}
    </div>
  );
};

export default ListSkeleton;
